const venta = {
  defaults: {
    venta: {
      __typename: 'venta',
      import: 0,
      fecha: '',
      idComprador: '',
      idOrganismo: '',
      idDetalle_Venta: '',
    },
    detalleVenta: {
      __typename: 'detalleVenta',
      _id: '',
      detalle: [],
    },
    datosPosnet: {
      __typename: 'datosPosnet',
      codigoOperacion: '',
      numeroTicket: '',
    },
    datosMP: {
      __typename: 'datosMP',
      numeroComprobante: '',
    },
    reciboVenta: {
      __typename: 'reciboVenta',
      email: '',
      enviarPorEmail: false,
      descargarRecibo: false,
    },
  },
  resolvers: {
    Mutation: {
      agregarDetalleVenta(_, { detalle_venta }, { cache }) {
        // console.log('ENTRE AL RESVOLVER', detalle_venta);
        cache.writeData({
          data: {
            detalleVenta: {
              __typename: 'detalleVenta',
              detalle: detalle_venta,
            },
          },
        });

        return null;
      },
      agregarDatosPosnet(_, { datosPosnet }, { cache }) {
        cache.writeData({
          data: {
            datosPosnet: {
              __typename: 'datosPosnet',
              codigoOperacion: datosPosnet.codigoOperacion,
              numeroTicket: datosPosnet.numeroTicket,
            },
          },
        });

        return null;
      },
      agregarDatosMP(_, { datosMP }, { cache }) {
        cache.writeData({
          data: {
            datosMP: {
              __typename: 'datosMP',
              numeroComprobante: datosMP.numeroComprobante,
            },
          },
        });

        // return null;
        return datosMP;
      },
      resetDatosPosnet(_, data, { cache }) {
        cache.writeData({
          data: {
            datosPosnet: {
              __typename: 'datosPosnet',
              codigoOperacion: '',
              numeroTicket: '',
            },
          },
        });

        return null;
      },
      resetDatosVenta(_, data, { cache }) {
        cache.writeData({
          data: {
            datosPosnet: {
              __typename: 'datosPosnet',
              codigoOperacion: '',
              numeroTicket: '',
            },
            detalleVenta: {
              __typename: 'detalleVenta',
              _id: '',
              detalle: [],
            },
          },
        });

        return null;
      },
      agregarDatosRecibo(_, { datosRecibo }, { cache }) {
        cache.writeData({
          data: {
            reciboVenta: {
              __typename: 'reciboVenta',
              email: datosRecibo.email,
              enviarPorEmail: datosRecibo.enviarPorEmail,
              descargarRecibo: datosRecibo.descargarRecibo,
            },
          },
        });

        return null;
      },
      resetDatosRecibo(_, data, { cache }) {
        cache.writeData({
          data: {
            reciboVenta: {
              __typename: 'reciboVenta',
              email: '',
              enviarPorEmail: false,
              descargarRecibo: false,
            },
          },
        });

        return null;
      },
    },
  },
};

export default venta;
